var exports = {
  "Sh": "token__z2AEfw",
  "vI": "tokenContent__rsjdC6",
  "Rs": "tokenCaret__1lnMS0",
  "RC": "stickyText__O7YTc5",
  "T0": "stickyIcon__2iHm9P",
};

module.exports = exports;
